'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');let

TreeListDirectiveController=class TreeListDirectiveController extends BaseController{
constructor($scope,uncaughtErrorHandler,sidebarScrollingService){
super(uncaughtErrorHandler,void 0,$scope);

this._sidebarScrollingService=sidebarScrollingService;
this._expandedItems=this.expandedItems||null;

$scope.$watchGroup([
'controller.selectedItem',
'controller.expandedItems'],
_.debounce(()=>this._scrollToSelection(this.selectedItem),150));

this._resetItemToElementMap();
this._safeWatch('items',(n,o)=>this._resetItemToElementMap());
}

get _isInitialized(){
return _.exists(this._expandedItems);
}

_resetItemToElementMap(){
this.itemToElementMap=new Map;
}

async _scrollToSelection(item){
await this._sidebarScrollingService.scrollToSelection(item,this.itemToElementMap);
}

toggleIsExpanded(item){
if(!this._isInitialized){
return;
}

if(this.isExpanded(item)){
this._expandedItemSet.delete(item);
}else{
this._expandedItemSet.add(item);
}

this._expandedItems=[...this._expandedItemSet];
}

isExpanded(item){
return this._isInitialized&&this._expandedItemSet.has(item);
}

set expandedItems(newExpandedItems){
if(!_.exists(newExpandedItems)){
return;
}

this._expandedItems=newExpandedItems;
this._expandedItemSet=new Set(newExpandedItems);
}

get expandedItems(){
return this._expandedItems;
}};let


TreeListDirective=class TreeListDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['items','selectedItem','order','expandedItems'];
}

get templateUrl(){
return'/templates/directives/treeListDirective/treeListTemplate';
}

get controller(){
return TreeListDirectiveController;
}

factory(){
let directive=super.factory();
directive.transclude=!0;
return directive;
}};


module.exports=TreeListDirective;
//# sourceMappingURL=treeListDirective.js.map
